export type WidgetType =
    'approvalTable'
    | 'BusinessKpi'
    | 'DigitalSignature'
    | 'FlowChart'
    | 'GroupStates'
    | 'LogbookTable'
    | 'ReconciliationMeasure'
    | 'TableByGroup'
    | 'ValidatedValueSelection'
    | 'businessKpi'
    | 'chartByIdentifier'
    | 'connectionPoint'
    | 'dashboardThumbnail'
    | 'flowChart'
    | 'gaugeChart'
    | 'groupStates'
    | 'groupsTree'
    | 'scatter'
    | 'seriesSelection'
    | 'spotValuesWidget'
    | 'table'
    | 'tagsTrend'
    | 'text'
    | 'tile';

export const boundWidgets = [
    'AlarmsHeatMap',
    'DigitalSignature',
    'DoughnutChart',
    'LogbookTable',
    'TableByGroup',
    'approvalTable',
    'chartByIdentifier',
    'gaugeChart',
    'pivotTable',
    'qualityBadActors',
    'scatter',
    'spotValuesWidget',
    'table',
    'tagsTrend',
];

export const renamableWidgets = [
    'FlowChart',
    'TableByGroup',
    'Tile',
    'businessKpi',
    'chartByIdentifier',
    'flowChart',
    'gaugeChart',
    'scatter',
    'table',
    'tagsTrend',
];